// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';

const logoutResponseSchema = z
  .object({
    data: z.object({ success: z.boolean() }),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    success: data.success,
  }));

type LogoutResponse = z.infer<typeof logoutResponseSchema>;

/**
 * Requests the current user be logged out from the remote API.
 */
export async function logout(): Promise<LogoutResponse> {
  const response = await api.post('/meta/logout');

  return parseResponse(logoutResponseSchema, response.data, {
    schemaName: 'Logout',
    endpoint: '/meta/logout',
  });
}
